import { InjectionToken } from '@angular/core';

export const CORE_INTERNAL_API_DEFAULT_DELAY = new InjectionToken<number>('CORE_INTERNAL_API_DEFAULT_DELAY');
